import React, { useState, useEffect } from "react";
import RequestHandler from "util/RequestHandler";
import { defaultValidateMessages } from "./Helper";

import { Form, Col, Row, Button, Input, Switch, Select } from "antd";
import { PlusOutlined } from "@ant-design/icons";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};

const PaymentSetUpdateForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const [posCommissions, setPosCommissions] = useState([]);

  const [selectedValue, setSelectedValue] = useState([]);

  useEffect(() => {
    form.resetFields();

    RequestHandler.get(`/PosCollectionCommissionDefinition`).then(
      (response) => {
        setPosCommissions(response.value);
      }
    );

    if (props.data) {
      Object.keys(props.data).forEach((key) => {
        if (props.data[key] == null) {
          delete props.data[key];
        }
      });

      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const onFinish = (values) => {
    const banks = [];

    for (let index = 1; index <= 12; index++) {
      if (values[`isInstallmentActive${index}`] != undefined) {
        values[`isInstallmentActive${index}`].map((bankInfo) => {
          let isPushArray = true;
          const hasBanks = banks.find(
            (x) => x.posCollectionCommissionDefinitionId == bankInfo
          );

          let bankObj = {};

          if (hasBanks) {
            isPushArray = false;
            bankObj = hasBanks;
          }

          bankObj[`isInstallmentActive${index}`] = true;

          if (isPushArray) {
            bankObj["posCollectionCommissionDefinitionId"] = bankInfo;
            banks.push(bankObj);
          }
        });
      }
    }

    values.banks = banks;

    RequestHandler.put(`/PaymentSet`, values)
      .then((response) => {
        setLoading(false);
        if (response.success) {
          form.resetFields();
          if (props.onSuccess) props.onSuccess();
        }
      })
      .catch(function (error) {
        setLoading(false);
      });
  };

  const renderInstallmentInput = (installmentCount) => {
    return (
      <Form.Item
        label={installmentCount + " Taksit Aktif"}
        name={"isInstallmentActive" + installmentCount}
      >
        <Select
          mode="multiple"
          allowClear
          showSearch
          placeholder="Aktif olmasını istediğiniz bankaları seçiniz."
          filterOption={(input, option) =>
            option.children
              .toLocaleLowerCase("tr-TR")
              .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
          }
        >
          {posCommissions.map((item) => (
            <Select.Option key={item.id} value={item.id}>
              {item.bankName + " (" + item.cardName + ")"}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    );
  };

  return (
    <>
      <Form
        {...formItemLayout}
        validateMessages={defaultValidateMessages}
        form={form}
        name="paymentSetUpdate"
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={() => setLoading(false)}
      >
        <Row>
          <Col span={24}>
            <Form.Item name="id" hidden>
              <Input />
            </Form.Item>

            <Form.Item
              label="Ödeme Seti Adı"
              name="name"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item label="Tek Çekim Aktif" name="isInstallmentActive1">
              <Select
                mode="multiple"
                allowClear
                showSearch
                placeholder="Aktif olmasını istediğiniz bankaları seçiniz."
                filterOption={(input, option) =>
                  option.children
                    .toLocaleLowerCase("tr-TR")
                    .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                }
              >
                {posCommissions.map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.bankName + " (" + item.cardName + ")"}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            {renderInstallmentInput(2)}
            {renderInstallmentInput(3)}
            {renderInstallmentInput(4)}
            {renderInstallmentInput(5)}
            {renderInstallmentInput(6)}
            {renderInstallmentInput(7)}
            {renderInstallmentInput(8)}
            {renderInstallmentInput(9)}
            {renderInstallmentInput(10)}
            {renderInstallmentInput(11)}
            {renderInstallmentInput(12)}
          </Col>
        </Row>
        <Row justify="space-between">
          <Col></Col>
          <Col>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              htmlType="submit"
              onClick={() => setLoading(true)}
              loading={loading}
            >
              Güncelle
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  );
};
export default PaymentSetUpdateForm;
